<template>
    <div v-if="!eventLoading && event" class="d-flex flex-row">
        <div class="leftcolumn">
            <div class="mainimagecontainer mb-4">
                <img class="mainimage" :src="event.backgroundImage || getDefaultBackground()" />
            </div>
            <Paper class="mb-4"><div class="p-4" v-html="event.description"></div></Paper>
        </div>
        <div class="flex-grow-1">
            <Paper class="p-4 mb-4">
                <div class="d-flex flex-column">
                    <div v-if="event.thumbnail" class="d-flex flex-row justify-content-center mb-3">
                        <img :src="event.thumbnail" class="logo" />
                    </div>
                    <div class="eventtitle mb-4">{{ event.title }}</div>
                    <div class="eventinfoheader">Date</div>
                    <div class="eventinfovalue">{{ date }}</div>
                    <div class="eventinfoheader">Time</div>
                    <div class="eventinfovalue">{{ time }}</div>
                    <div class="eventinfoheader">Status</div>
                    <div v-if="live">
                        <div class="my-3">
                            <span class="live">
                                Live now
                            </span>
                        </div>
                        <a
                            v-if="event.url"
                            class="joinbutton btn btn-success w-100"
                            :href="event.url"
                            target="_blank"
                            >Join the event</a
                        >
                    </div>
                    <div v-else-if="completed" class="eventinfovalue completed">
                        Completed
                    </div>
                    <div v-else>
                        <Countdown
                            caption="Starts in"
                            :timestamp="startTimeStamp"
                            :plainText="true"
                            class="eventinfovalue"
                        ></Countdown>
                        <div class="eventinfoheader">(Link will show when the event goes live)</div>
                    </div>
                </div>
            </Paper>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Countdown from '../components/Countdown';

import defaultBackground from '~/assets/img/vcf/event-default-bg.png';

export default {
    name: 'Event',
    components: {
        Countdown,
    },
    data() {
        return {
            live: false,
            completed: false,
            interval: null,
        };
    },
    computed: {
        eventData() {
            if (!this.$route.params.eventId) {
                return undefined;
            } else {
                return this.$interfaces.vfair
                    .id(this.$route.params.id)
                    .events.id(this.$route.params.eventId)
                    .get({
                        reactive: true,
                    });
            }
        },
        event() {
            if (Array.isArray(this.eventData.data)) return undefined;
            return this.eventData.data;
        },
        eventLoading() {
            return this.eventData.loading;
        },
        date() {
            const timestamp = new moment(this.event.startTime);
            return timestamp.format('D MMMM YYYY');
        },
        startTimeStamp() {
            return new Date(this.event.startTime);
        },
        time() {
            const timestamp = new moment(this.event.startTime);
            return timestamp.format('H:mm');
        },
    },
    methods: {
        timerTick() {
            if (this.event) {
                const start = new moment(this.event.startTime);
                const end = new moment(this.event.endTime);
                this.live = moment().isBetween(start, end);

                this.completed = moment().isAfter(this.event.endTime);
            }
        },
        getDefaultBackground() {
            return defaultBackground;
        },
    },
    mounted() {
        this.timerTick();
        this.interval = setInterval(this.timerTick, 1000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    },
};
</script>

<style scoped>
.leftcolumn {
    width: 65%;
    margin-right: 22px;
}
.mainimagecontainer {
    width: 100%;
    padding-top: 38%;
    position: relative; /* If you want text inside of it */
}

.mainimage {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: cover;
}
.eventtitle {
    font-size: 18px;
    text-align: center;
}
.eventinfoheader {
    text-transform: uppercase;
    font-size: 12px;
    color: #b7b7b7;
}
.eventinfovalue {
    font-size: 14px;
    color: #323c53;
    margin-bottom: 1em;
}
.logo {
    width: 80%;
    height: 80px;
    object-fit: contain;
}
.live {
    background: #f00;
    color: #fff;
    text-transform: uppercase;
    padding: 4px 6px 2px 6px;
}
.completed {
    color: #f00;
}
.joinbutton {
    color: #fff !important;
}
</style>
